<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-image-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
            </button>

            <h4 class="modal-title">
              Create Image
            </h4>
          </div>

          <div class="modal-body">
            <text-form-group
                v-model="data.title"
                name="title"
                label="Title"
                :error="getError('title')"
            />

            <text-form-group
                v-model="data.credit"
                name="credit"
                label="Credit"
                :error="getError('credit')"
            />

            <text-form-group
                v-model="data.alt"
                name="alt"
                label="Alt"
                :error="getError('alt')"
            />

            <form-group name="file" label="File" :error="getError('file')">
              <input
                  v-if="uploadReady"
                  type="file"
                  class="form-control"
                  id="file"
                  @change="data.file = $event.target.files[0]"
              >
            </form-group>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import FormGroup from '@/vendor/forms/FormGroups/Block/FormGroup'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {FormGroup, TextFormGroup},

  mixins: [Errors],

  data() {
    return {
      data: {},

      uploadReady: true
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/images', this.getFormData())
          .then(response => {
            notify.success('The image was saved')

            this.$emit('created', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    getFormData() {
      let formData = new FormData()

      formData.append('title', this.data.title || '')
      formData.append('credit', this.data.credit || '')
      formData.append('alt', this.data.alt || '')
      formData.append('file', this.data.file)

      return formData
    },

    reset() {
      this.errors = {}

      this.uploadReady = false

      this.$nextTick(() => {
        this.uploadReady = true
      })

      this.data = {}
    }
  }
}
</script>
